<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent transition="scale-transition" max-width="720px">
            <v-card class="elevation-1">
                <ValidationObserver ref="refPayRaya" v-slot="{ invalid, validated }">
                    <v-form name="form" @submit.prevent="savePayment">
                        <v-toolbar dark color="primary">
                            <v-btn icon dark @click.native="handleModalPayment">
                                <v-icon>fas fa-times-circle</v-icon>
                            </v-btn>
                            <v-toolbar-title>Realizar pago</v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn class="primary" type="submit" :disabled="invalid || !validated">
                                    <v-icon class="ma-2" dense large left>fas fa-save</v-icon>Guardar pago
                                </v-btn>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field :value="raya.fechaInicio + ' - ' + raya.fechaFin"
                                        label="Detalle de raya" readonly></v-text-field>
                                </v-col>
                                <!-- <v-col cols="12" sm="6" md="6">
                                    <v-text-field :value="rayaDetalle.estatus" label="Estatus" readonly></v-text-field>
                                </v-col> -->
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field :value="rayaDetalle.empleado.nombreCompleto" label="Folio de pago"
                                        readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field :value="rayaDetalle.salarioDiario" label="Salario diario"
                                        readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field :value="rayaDetalle.diasTrabajados" label="Dias trabajados"
                                        readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field :value="rayaDetalle.bonos" label="Bonos" readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field :value="rayaDetalle.deducciones" label="Deducciones"
                                        readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field :value="rayaDetalle.netoPagar" label="Neto a pagar"
                                        readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" v-if="rayaDetalle.comentarios != ''">
                                    <v-text-field :value="rayaDetalle.comentarios" label="Comentarios"
                                        readonly></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row v-if="lstSells.length > 0">
                                <v-col cols="12" sm="12" md="12">
                                    <v-simple-table fixed-header height="auto" dense class="elevation-1">
                                        <template v-slot:default>
                                            <thead class="text-left teal darken-4 font-weight-bold">
                                                <th class="indigo darken-4 white--text font-weight-bold">Folio venta
                                                </th>
                                                <th class="indigo darken-4 white--text font-weight-bold">Fecha venta
                                                </th>
                                                <th class="indigo darken-4 white--text font-weight-bold">Total</th>
                                                <th class="indigo darken-4 white--text font-weight-bold">Abonado</th>
                                                <th class="indigo darken-4 white--text font-weight-bold">Saldo</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="sell in lstSells" :key="sell.id" class="font-weight-bold">
                                                    <td>{{ sell.ticketFolio }}</td>
                                                    <td>{{ sell.registerDate }}</td>
                                                    <td>{{ sell.totalNatural }}</td>
                                                    <td>{{ sell.abonadoNatural }}</td>
                                                    <td>{{ sell.saldoNatural }}</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <h6 class="text-left font-weight-bold indigo--text text--darken-2">Favor de considerar la cobranza de las ventas pendientes</h6>
                                            </tfoot>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                            <div class="row">
                                <v-col cols="12" sm="12" md="12">
                                    <ValidationProvider rules="required" v-slot="{ errors, valid }" :immediate="true">
                                        <v-autocomplete :items="lstCashRegisters" item-text="opened" item-value="id"
                                            v-model="paymentRaya.cashRegister" label="Caja registradora" required
                                            prepend-inner-icon="fas fa-layer-group" chips small-chips persistent-hint
                                            :error-messages="errors" :success="valid" multiple>
                                            <template v-slot:no-data>
                                                <v-list-item>
                                                    <v-list-item-title>No hay cajas abierta<strong> para la sucursal que
                                                            pertenece.</strong></v-list-item-title>
                                                </v-list-item>
                                            </template>
                                            <template v-slot:item="{ item }">
                                                <div style="padding: 4px;">
                                                    <div>
                                                        <span style="font-weight: 600; color: #1976D2;">Usuario: </span>
                                                        <span class="font-weight-bold dark--text">{{ item.user }}</span>
                                                    </div>
                                                    <div style="font-size: 12px; color: #757575;">
                                                        {{ item.sucursal }} - {{ item.opened }}
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-slot:selection="{ attr, on, item, selected }">
                                                <v-chip v-bind="attr" :input-value="selected" color="blue darken-3"
                                                    class="white--text font-weight-normal rounded p-0" v-on="on">
                                                    <span v-text="' Usuario: ' + item.user + ' - ' + item.sucursal + ' - ' + item.opened"></span>
                                                </v-chip>
                                            </template>
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                            </div>
                            <div class="row" v-if="paymentRDCashRegister.length > 0">
                                <v-col cols="12" sm="12" md="12">
                                    <v-simple-table fixed-header height="auto" dense class="elevation-1">
                                        <template v-slot:default>
                                            <thead class="text-left teal darken-4 font-weight-bold">
                                                <th class="primary text-center darken-4 white--text font-weight-bold">Encargado</th>
                                                <th class="primary text-center darken-4 white--text font-weight-bold">Folio caja</th>
                                                <th class="primary text-center darken-4 white--text font-weight-bold">Fecha apertura</th>
                                                <!-- <th class="primary text-center darken-4 white--text font-weight-bold">Disponible</th> -->
                                                <th class="primary text-center darken-4 white--text font-weight-bold">Disponer</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="pRDCashReg in paymentRDCashRegister" :key="pRDCashReg.cashRegisterId" class="font-weight-bold">
                                                    <td>{{ pRDCashReg.cashRegister.user }}</td>
                                                    <td>{{ pRDCashReg.cashRegister.folio }}</td>
                                                    <td>{{ pRDCashReg.cashRegister.opened }}</td>
                                                    <!-- <td>{{ pRDCashReg.cashRegister.closingAmountNatural }}</td> -->
                                                    <td>
                                                        <ValidationProvider :rules="`required|decimal|min_value:0.5|max_value:${rayaDetalle.netoPagarDecimal}`"
                                                        v-slot="{ errors, valid }" :immediate="true">
                                                            <v-text-field :value="pRDCashReg.amount" v-model.number="pRDCashReg.amount" type="number" solo hide-details
                                                                prepend-inner-icon="fas fa-cash-register" class="mt-2 font-weight-black text-h6" :max="rayaDetalle.netoPagarDecimal"
                                                                :error-messages="errors" :success="valid"></v-text-field>
                                                        </ValidationProvider>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </div>
                        </v-card-text>
                    </v-form>
                </ValidationObserver>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import { showErrorAlert, showSuccessAlert } from '@/helpers/swalHelper';
import CashRegisterDataService from '@/service/cashRegister/CashRegisterDataService';
import RayaDetalleDataService from '@/service/raya/RayaDetalleDataService';
import VentaDataService from '@/service/venta/VentaDataService';
import { getToday } from '@/utils/DateUtil';
import { ValidationProvider } from 'vee-validate';
export default {
    name: "PaymentRaya",
    props: {
        dialog: { type: Boolean, default: false },
        raya: { type: Object, default: {} },
        rayaDetalle: { type: Object, default: {} },
        handleModalPayment: { type: Function },
        initialize: { type: Function }
    },
    created() {
        this.getCashRegisters();
        this.getSellByEmployee();
    },
    data() {
        return {
            lstSells: [],
            lstCashRegisters: [],
            paymentRaya: {
                rayaDetalleId: this.rayaDetalle.id,
                cashRegister: [],
                paymentDate: getToday().toFormat('dd/MM/yyyy'),
            },
            paymentRDCashRegister: [],
        }
    },
    methods: {
        getCashRegisters() {
            CashRegisterDataService.findCashRegisterOpened().then(response => {
                this.lstCashRegisters = response.data;
            }).catch(error => {
                showErrorAlert({ title: 'Error al obtener los datos', text: error?.response?.data });
            })
        },
        getSellByEmployee() {
            VentaDataService.findByCreditEmployee(this.rayaDetalle.empleado.id).then(response => {
                this.lstSells = response.data;
            }).catch(error => {
                showErrorAlert({ title: 'Error al obtener los datos', text: error?.response?.data });
            })
        },
        builtPaymentRayaDetailCashRegister() {
            const selectedIds = this.paymentRaya.cashRegister;
            // 1️⃣ ADD new selections
            this.lstCashRegisters.forEach(cashRegister => {
                if (
                selectedIds.includes(cashRegister.id) &&
                !this.paymentRDCashRegister.some(
                    payment => payment.cashRegisterId === cashRegister.id
                )
                ) {
                this.paymentRDCashRegister.push({
                    cashRegister,
                    rayaDetalleId: this.rayaDetalle.id,
                    cashRegisterId: cashRegister.id,
                    paymentDate: this.paymentRaya.paymentDate,
                    status: 'PAID',
                    amount: 0, // each register keeps its own amount
                });
                }
            });
            // 2️⃣ REMOVE unselected ones
            this.paymentRDCashRegister = this.paymentRDCashRegister.filter(payment =>
                selectedIds.includes(payment.cashRegisterId)
            );
        },
        savePayment() {
            try {
                const isValid = this.$refs.refPayRaya.validate();
                if (this.getTotalPayment !== this.rayaDetalle.netoPagarDecimal) {
                    showErrorAlert({ title: 'Error', text: 'El total de pagos no es igual al neto a pagar' });
                    return;
                }
                if (!isValid) return;
                RayaDetalleDataService.paid(this.rayaDetalle.id, this.paymentRDCashRegister).then(_ => {
                    this.initialize();
                    showSuccessAlert({ title: 'Pago registrado', text: 'Pago registrado exitosamente' });
                    this.handleModalPayment();
                }).catch(error => {
                    showErrorAlert({ title: 'Error al obtener los datos', text: error });
                })
            } catch (error) {
                showErrorAlert({ title: 'Error al obtener los datos', text: error?.response?.data });
            }
        }
    },
    watch: {
        'paymentRaya.cashRegister': {
            deep: true,
            handler() {
                this.builtPaymentRayaDetailCashRegister();
            }
        },
    },
    computed: {
        getTotalPayment() {
            const total = this.paymentRDCashRegister.reduce(
                (acc, item) => acc + Number(item.amount),
                0
            );
            return Number(total.toFixed(2));
        }
    }
}
</script>